"use strict";
define(
'stores/notifications',[
    "jquery",
    "stores/store",
    "actions/notifications",
    "constants/actiontypes"
],
function ($, StoreBase, Action, Constants)
{
    Store.prototype = new StoreBase();
    Store.constructor = Store;

    function Store (params)
    {
        // Call parent constructor
        StoreBase.call(this, params);

        // Setup the instance
        this.notifications = {};
        this.sortedNotifications = [];
        this.unreadCount = 0;

        this.registerDispatchListener(function (action) {
            switch(action.actionType) {
                case Constants.CREATE_NOTIFICATION:
                    if (Array.isArray(action.data)) {
                        _.each(action.data, function (data, index, list) {
                            this.addNotification(data);
                        }, this);
                    } else {
                        this.addNotification(action.data);
                    }
                    this.sortNotifications();
                    this.event.emit("change");
                    break;
                case Constants.SORT_NOTIFICATIONS:
                    this.sortNotifications();
                    this.event.emit("change");
                    break;
                case Constants.MARK_NOTIFICATION_READ:
                    // debugger;
                    this.markRead(action.data.guid);
                    break;
            }
        }.bind(this));

        this.action = new Action();
        // this.action.pull();
    }

    Store.prototype.addNotification = function(data)
    {
        this.notifications[data.guid] = data;
        this.notifications[data.guid].read = !(data.read_at === null);
    };

    Store.prototype.sortNotifications = function() {
        var self = this;
        var values = Object.keys(this.notifications).map(function(key) {
            return self.notifications[key]
        });
        this.sortedNotifications = _.sortBy(values, function(notification){return notification.updated_at}).reverse();
        this.unreadCount = _.filter(values, function(notification) {
            return !notification.read
        }).length
    }

    Store.prototype.getAll = function() {
        return this.sortedNotifications;
    }

    Store.prototype.getAllUnread = function() {
        return _.filter(this.sortedNotifications, function(notification) {
            return !notification.read
        });
    }

    Store.prototype.markRead = function(guid) {
        this.notifications[guid].read = true;
        for(guid in this.sortedNotifications) {
            if(this.sortedNotifications.guid === guid) {
                this.sortedNotifications.guid.read = true
            }
        }
    }

    Store.prototype.resetCount = function() {
        this.unreadCount = 0;
    }

    return Store;
});

